import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const BecomeCurator = lazy(() => import("@/pages/BecomeCurator"));

export const Route = createFileRoute("/_public/become-curator")({
  component: BecomeCurator,
});
